import { render, staticRenderFns } from "./TextJoinBehaviorEditor.vue?vue&type=template&id=c4023526&scoped=true&"
import script from "./TextJoinBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./TextJoinBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextJoinBehaviorEditor.vue?vue&type=style&index=0&id=c4023526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4023526",
  null
  
)

export default component.exports